"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_CATEGORIES = void 0;
var COOKIE_CATEGORIES;
(function (COOKIE_CATEGORIES) {
    COOKIE_CATEGORIES["essential"] = "essential";
    COOKIE_CATEGORIES["performance"] = "performance";
    COOKIE_CATEGORIES["analytics"] = "analytics";
    COOKIE_CATEGORIES["advertising"] = "advertising";
})(COOKIE_CATEGORIES = exports.COOKIE_CATEGORIES || (exports.COOKIE_CATEGORIES = {}));
//# sourceMappingURL=types.js.map